import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { Box, Spinner } from "@salestrak/ui";
import {
  useWebhooks,
  useWebhookMutations,
} from "#app/hooks/settings/use-webhook-mutations";
import { WebhookDetailView } from "#app/components/settings/webhook-detail-view";
import { TrashConfirmDialog } from "#app/components/settings/trash-confirm-dialog";
import { useAppNavigate } from "#app/lib/hooks/use-app-navigate";
import { withPermission } from "#app/components/permissions/require-permission";

function WebhookDetailPage() {
  const { webhookId } = Route.useParams();
  const { push, replace } = useAppNavigate();
  const { webhooks, isLoading } = useWebhooks();
  const { deleteWebhook, toggleWebhookArchived } = useWebhookMutations();

  const [showDelete, setShowDelete] = useState(false);

  const webhook = webhooks.find((w) => w.webhookId === webhookId);

  if (isLoading && !webhook) {
    return (
      <Box fill="flex" align="center" justify="center">
        <Spinner />
      </Box>
    );
  }

  if (!webhook) {
    replace("/settings/api");
    return null;
  }

  async function handleDelete() {
    await deleteWebhook(webhookId);
    replace("/settings/api");
  }

  return (
    <>
      <WebhookDetailView
        webhook={webhook}
        onBack={() => replace("/settings/api")}
        onEdit={() =>
          push(`/settings/api/webhooks/${webhookId}/edit`)
        }
        onToggleArchived={() => toggleWebhookArchived(webhook)}
        onDelete={() => setShowDelete(true)}
      />

      <TrashConfirmDialog
        open={showDelete}
        onOpenChange={(open) => { if (!open) setShowDelete(false); }}
        title="Delete webhook?"
        description={`This will permanently delete the webhook for ${webhook.url}. This action cannot be undone.`}
        confirmLabel="Delete"
        onConfirm={handleDelete}
      />
    </>
  );
}

export const Route = createFileRoute(
  "/(app)/$workspace/settings/api/webhooks/$webhookId/",
)({ component: withPermission("workspace.integrations", WebhookDetailPage) });
